module.exports = __webpack_public_path__ + "media/components/assets/logo-923759d1403858afd4b2b788420191ba.svg";